import React from 'react';

import { EditorState } from 'draft-js';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Details } from 'assets/assetsV1/iconComponents';

import { getQueryParams } from 'constants/helper';
import { sendUsedMeshMavenGeneratedContentEvent } from 'constants/mixpanelHelper';
import { sendCFGenAISuggestionUsedEvent } from 'constants/mixpanelHelpers/cfGenAIEvents';

import { Button } from 'uiToolkitV1/Button';

import { useCustomerFeedbackMutation } from '../../hooks/meshMavenDataHooks';
import { useFeedbackData } from '../../slice/feedbackSlice';

interface Props {
  onCloseSecondaryPanel: () => void;
}

const MeshMavenFooter = ({ onCloseSecondaryPanel }: Props) => {
  const dispatch = useDispatch();
  const { setFeedbackPost, selectedRevision } = useFeedbackData();
  const { mutate: submitCustomerFeedback } = useCustomerFeedbackMutation();
  const history = useHistory();
  const { source } = getQueryParams(history.location.search);

  const onSelectContent = () => {
    sendCFGenAISuggestionUsedEvent({
      eventProperties: {
        source,
      },
    });
    sendUsedMeshMavenGeneratedContentEvent({
      eventProperties: {
        source: 'Share Feedback',
      },
    });
    dispatch(
      setFeedbackPost({
        feedbackPost: EditorState.createWithContent(selectedRevision.updatedState.getCurrentContent()),
      })
    );
    submitCustomerFeedback({ userAction: 'USE' });
    onCloseSecondaryPanel();
  };

  return (
    <>
      <Button variant="tertiary" mr="auto" onClick={onCloseSecondaryPanel}>
        Cancel
      </Button>
      <Button onClick={onSelectContent} StartIcon={Details} startIconProps={{ fill: 'none' }}>
        Use this Content
      </Button>
    </>
  );
};

export default MeshMavenFooter;
